import React from "react";

export default function Footer() {
  return (
    <footer className="mt-12 bg-[#00477B] text-white">
      <div className="max-w-7xl mx-auto px-6 py-10 grid grid-cols-1 md:grid-cols-3 gap-8">
        {/* Brand and Mission */}
        <div>
          <h2 className="text-2xl font-bold">ProseMediStore</h2>
          <p className="mt-2 text-sm text-gray-200 leading-relaxed">
            Trusted Care, Every Time. Virtual consultations with doctors and pharmacists, and genuine medicines, delivered with care.
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <h3 className="text-lg font-semibold mb-3">Quick Links</h3>
          <ul className="space-y-2 text-sm text-gray-200">
            <li>
              <a href="https://wa.me/2348162738527" target="_blank" rel="noopener noreferrer" className="hover:text-[#50D6FE] transition">
                Consult an Expert
              </a>
            </li>
            <li><a href="/shop" className="hover:text-[#50D6FE] transition">Shop</a></li>
            <li><a href="/about" className="hover:text-[#50D6FE] transition">About Us</a></li>
            <li><a href="/install" className="hover:text-[#50D6FE] transition">How to Install</a></li>
            <li><a href="/contact" className="hover:text-[#50D6FE] transition">Contact</a></li>
            <li><a href="/privacy" className="hover:text-[#50D6FE] transition">Privacy Policy</a></li>
          </ul>
        </div>

        {/* Contact Info */}
        <div>
          <h3 className="text-lg font-semibold mb-3">Contact</h3>
          <p className="text-sm text-gray-200">
            📍 <span className="text-gray-100">Administrative Office: 3C7J+8PW, Utako, Abuja, Nigeria.</span>
          </p>
          <p className="mt-2 text-sm">
            📞 General inquiries (calls):{" "}
            <a href="tel:+2349072096805" className="hover:text-[#50D6FE] transition font-medium">
              +234 907 209 6805
            </a>
          </p>
          <p className="mt-1 text-sm">
            💬 Consultations (WhatsApp):{" "}
            <a href="https://wa.me/2348162738527" target="_blank" rel="noopener noreferrer" className="hover:text-[#50D6FE] transition font-medium">
              +234 816 273 8527
            </a>
          </p>
          <p className="mt-1 text-sm">
            📧{" "}
            <a href="mailto:prosemedistore@gmail.com" className="hover:text-[#50D6FE] transition">
              prosemedistore@gmail.com
            </a>
          </p>
        </div>
      </div>

      {/* Bottom Bar & Emergency Disclaimer */}
      <div className="border-t border-white/20 py-4 px-6 text-center text-xs text-gray-300 space-y-2">
        <p className="text-amber-200 font-medium">
          Not for emergencies. If you have a medical emergency, go to the nearest hospital immediately.
        </p>
        <p>© {new Date().getFullYear()} ProseMediStore All rights reserved.</p>
      </div>
    </footer>
  );
}